import { useQuery } from '@tanstack/react-query'

import { useAuthInfo } from '@sweetauth/core'

import { API_URL, IS_FEDRAMP_ENVIRONMENT } from '@/constants/env'

import type { NotificationTokenResponse } from '@/types/Notification'

const fetchToken = async (
  accessToken: string | undefined | null,
): Promise<string> => {
  if (accessToken === null || accessToken === undefined) {
    throw new Error('No access token provided.')
  }
  const res: Response = await fetch(`${API_URL}/api/v1/notifications/token`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
  })
  if (!res.ok) {
    throw new Error(res.statusText)
  }
  const res_json: NotificationTokenResponse = await res.json()
  return res_json.token
}

export const useNotificationToken = () => {
  const { user, accessToken } = useAuthInfo()
  return useQuery({
    queryFn: () => fetchToken(accessToken),
    queryKey: [user?.userId, 'notificationToken'],
    enabled: !!user && !IS_FEDRAMP_ENVIRONMENT,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  })
}
